// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"UserPage_toolbar__2h8og","buttons":"UserPage_buttons__2UQCd","save":"UserPage_save__eXkVe","delete":"UserPage_delete__3exsW","back":"UserPage_back__YEKg3"};